import React from "react";
import { Input, Form } from "antd";
import "./Style.css";

export const TextInput = (props) => {
  const FormItem = Form.Item;
  const {
    title,
    name,
    type,
    disabled,
    validation,
    addonAfter,
    tabIndex,
    onCopy,
    onPaste,
    onCut,
    onChange,
    maxLength,
    bordered,
    placeholder,
    value,
    defaultValue,
    style,
    onBlur,
    minLength,
    ref,
    onFocus,
    onInput,
    minValue,
    maxValue,
    autoComplete,
  } = props;

  const handleKeyDown = (event) => {
    // Allow backspace, delete, tab, escape, enter, and number keys
    if (
      event.key === "Backspace" ||
      event.key === "Delete" ||
      event.key === "Tab" ||
      event.key === "Escape" ||
      event.key === "Enter" ||
      (event.key >= "0" && event.key <= "9") ||
      (event.key >= "Numpad0" && event.key <= "Numpad9")
    ) {
      return;
    }

    // Prevent all other keys
    event.preventDefault();
  };

  return (
    <FormItem name={name} label={title} rules={validation}>
      <div>
        {type === "password" ? (
          <Input.Password
            className="text-input-password"
            name={name}
            value={value}
            tabIndex={tabIndex}
            defaultValue={value}
            onChange={onChange}
            onCopy={onCopy}
            onPaste={onPaste}
            onCut={onCut}
            placeholder={placeholder}
            maxLength={maxLength}
            style={style}
            disabled={disabled}
            autoComplete={autoComplete}
          />
        ) : type === "number" ? (
          <Input
            className="text-input-normal"
            precision="number"
            type="number"
            min={minValue}
            max={maxValue}
            name={name}
            tabIndex={tabIndex}
            id={name}
            onCopy={onCopy}
            onPaste={onPaste}
            onCut={onCut}
            value={value}
            maxLength={maxLength}
            placeholder={placeholder}
            onChange={onChange}
            style={style}
            disabled={disabled}
            onWheel={() => document.activeElement.blur()}
            onInput={onInput}
            onKeyDown={handleKeyDown}
            autoComplete={autoComplete}
          />
        ) : type === "tel" ? (
          <Input
            className="text-input-normal"
            precision="number"
            type={type}
            min={minValue}
            max={maxValue}
            name={name}
            tabIndex={tabIndex}
            id={name}
            onCopy={onCopy}
            onPaste={onPaste}
            onCut={onCut}
            value={value}
            maxLength={maxLength}
            placeholder={placeholder}
            onChange={onChange}
            style={style}
            disabled={disabled}
            onWheel={() => document.activeElement.blur()}
            onInput={onInput}
            onKeyDown={handleKeyDown}
            autoComplete={autoComplete}
          />
        ) : (
          <Input
            className="text-input-normal"
            style={style}
            name={name}
            type="text"
            value={value}
            bordered={true}
            placeholder={placeholder}
            defaultValue={value}
            tabIndex={tabIndex}
            disabled={disabled}
            onCopy={onCopy}
            onPaste={onPaste}
            onCut={onCut}
            maxLength={maxLength}
            onChange={onChange}
            onBlur={onBlur}
            ref={ref}
            onInput={onInput}
            onFocus={onFocus}
            autoComplete={autoComplete}
          />
        )}
      </div>
    </FormItem>
  );
};

export const NumberInput = (props) => {
  const FormItem = Form.Item;
  const {
    title,
    name,
    minValue,
    maxValue,
    tabIndex,
    validation,
    onChange,
    onCopy,
    onPaste,
    onCut,
    placeholder,
    value,
    type,
    maxLength,
    style,
    disabled,
  } = props;

  return (
    <FormItem name={name} rules={validation} label={title}>
      <div>
        <Input
          precision="number"
          type={type}
          min={minValue}
          max={maxValue}
          tabIndex={tabIndex}
          id={name}
          onCopy={onCopy}
          onPaste={onPaste}
          onCut={onCut}
          value={value}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={onChange}
          style={style}
          disabled={disabled}
        />
      </div>
    </FormItem>
  );
};

export default TextInput;
